export default __webpack_public_path__ + "static/media/processing.30e3f3fa.svg";